import React from "react";
import Skeleton from '../../components/skeleton/Dashboard'
import '../../assets/css/dashboard.scss'
import ErrorHandler from "../../class/ErrorHandler";
import {connect} from "react-redux";
import cookie from 'react-cookies'
import ArrowIcon from '../../assets/img/setting/arrow'
import EnlargeIcon from '../../assets/img/dashboard/enlarge'
import RecipeItem from './DemoRecipeItem'
import DeviceItem from '../../components/dashboard/DeviceItem'
import TimesIcon from '../../assets/img/times'
import Refresh from '../../components/Refresh'
import $ from 'jquery'
import DeviceSetting from '../../components/dashboard/DeviceSetting';
import democonstants from "./democonstants.js";

class DemoDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            familyId:"",
            familyName:"",
            recipeList:[],
            roomList:[],
            room:"0",
            roomName:"ALL",
            deviceList:[],
            openRecipe:true,
            openDevice:true,
            refresh:false,
            isEnlarge:false,
            toggle:false,
            panelToggle: false,
            selectedItem:null,
            key:Math.random(),
            reconnect: false,
            demo: true,
        } 
        this.errorHandler = new ErrorHandler(this);
        this.accessToken = cookie.load('accessToken');
        this.handlePanelToggle = this.handlePanelToggle.bind(this)
        this.closePanelToggle = this.closePanelToggle.bind(this)
        this.handleItemPower = this.handleItemPower.bind(this);
    }

    componentDidMount() {
        this.getFamilyId();
        
        // 자동 새로고침
        let refreshTerm = cookie.load('refreshTerm');
        if(refreshTerm==="60") {
            setInterval(()=>{
                this.setState({refresh:true})
                this.getDeviceList(this.state.familyId, this.state.room);
                this.props.setIsRefresh(false)
            },60000);
        } else if(refreshTerm==="30") {
            setInterval(()=>{
                this.setState({refresh:true})
                this.getDeviceList(this.state.familyId, this.state.room);
                this.props.setIsRefresh(false)
            },30000);
        }
        $(window).scroll(function(){
            $('.top-select').css('left', -$(window).scrollLeft());
            $('.enlarge-wrap').css('left', -$(window).scrollLeft());
        });

        $('body').on('click', '.user-info-box .info-wrap .btn', function(){
            this._onDisconnect();
        });
    }

    componentDidUpdate(prevProp, prevState) {       
        // 새로고침 버튼 클릭시 list 호출
        if(this.props.isRefresh) {

        cookie.remove('scene-id', { path: '/' });
            this.setState({refresh:true});
            this.getDeviceList(this.state.familyId, this.state.room);
            this.props.setIsRefresh(false)
        }
        // 전체화면 종료
        if(this.state.isEnlarge) {
            window.addEventListener('fullscreenchange', (e) => {
                if(!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                    this.setState({isEnlarge:false})
                    $('body').css('overflow-y','scroll')
                }
            });
        }
        if(this.state.selectedItem !== prevState.selectedItem){
            this.setState({selectedItem: this.state.selectedItem});
        }     
    }

    getFamilyId() {
        // let url = window.location.href;
        let familyId = cookie.load('familyId');
        let familyName= cookie.load('familyName');
        if(familyId) {this.setState({familyId:familyId})}
        else{
            familyId="0000001";
            this.setState({familyId:familyId});
        }
        if(familyName) this.setState({familyName: familyName})
        else{
            familyName="우리 집";
            this.setState({familyName:familyName})
        }
        this.getDeviceList(familyId, 0)
        this.getRoomList(familyId);
        this.getRecipe(familyId)
    }
    getRoomList(familyId) {
        let roomList = []
       if(familyId==="0000001"){
        roomList= [
            {
             name:"안방",
             room_id:"00000001"
            },
            {
             name:"거실",
             room_id:"00000002"
            },
        ]
       }
       if(familyId==="0000002"){
        roomList= [
            {
             name:"홀",
             room_id:"00000003"
            },
            {
             name:"주방 & 매대",
             room_id:"00000004"
            },
        ]
       }
       
       this.setState({
           roomList:roomList,
       })
    }

    getDeviceList(familyId, roomId, callback = () => {}) {
        // let roomIdNum = Number(roomId);
        let recipe= cookie.load('scene-id');
        //familyId와 roomId에 따라 나오는 값 다르게 해줘야 함
        let deviceList=[];
        if(familyId==="0000001" && roomId==="00000001"){

            deviceList = democonstants.HOMEROOMLIST;
            if(recipe==="mainroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="mainroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="livingroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="livingroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐"
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
        }
        else if(familyId==="0000001" && roomId==="00000002"){
            deviceList = democonstants.HOMELIVINGROOMLIST;
            if(recipe==="mainroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="mainroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="livingroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="livingroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐"
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
        }
        else if(familyId==="0000001"){
            deviceList = democonstants.HOMELIST;
            if(recipe==="mainroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="mainroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="livingroomRest"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="livingroomMovie"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close"
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
            else if(recipe==="allLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("main")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open"
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgb"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐";
                        }
                    }
                    if(v.id.indexOf("room")!==-1){
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
        }
        else if(familyId==="0000002" && roomId==="00000003"){
            deviceList = democonstants.CAFEHALLLIST;

            if(recipe==="hallGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="OPEN"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                    }
                })
            }
            else if(recipe==="hallLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="CLOSED"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                    }
                })
            }
            else if(recipe==="hallDayTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("kitchenMood")!==-1){
                        v.deviceState.power=false;
                    }
                })
            }
            else if(recipe==="hallNightTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="꺼짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
        }
        else if(familyId==="0000002" && roomId==="00000004"){
            deviceList = democonstants.CAFEKITCHENLIST;
            if(recipe==="hallGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="OPEN"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                    }
                })
            }
            else if(recipe==="hallLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="CLOSED"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                    }
                })
            }
            else if(recipe==="hallDayTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("kitchenMood")!==-1){
                        v.deviceState.power=false;
                    }
                })
            }
            else if(recipe==="hallNightTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="꺼짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
        }
        else if(familyId==="0000002"){
            deviceList = democonstants.CAFELIST;
            if(recipe==="hallGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="OPEN"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="open";
                            v.deviceState.percentControl="100"
                            v.deviceState.percentState="100"
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                    }
                })
            }
            else if(recipe==="hallLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="SensorDo"){
                            v.deviceState.state="CLOSED"
                        }
                        if(v.deviceType==="Curtain"){
                            v.deviceState.control="close";
                            v.deviceState.percentControl=0
                            v.deviceState.percentState="0"
                            
                        }
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                        }
                    }
                })
            }
            else if(recipe==="hallDayTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=false;
                        }
                    }
                    if(v.id.indexOf("kitchenMood")!==-1){
                        v.deviceState.power=false;
                    }
                })
            }
            else if(recipe==="hallNightTime"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("hall")!==-1){
                        if(v.deviceType==="Switch2"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LedStripRgbw1"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenGoToWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=true;
                            v.deviceState.power2=true;
                            v.deviceState.power3=true;
                            v.deviceState.power4=true;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="켜짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=true;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=true;
                        }
                    }
                })
            }
            else if(recipe==="kitchenLeaveWork"){
                (deviceList && deviceList.length!==0) && deviceList.forEach((v, k)=>{
                    if(v.id.indexOf("kitchen")!==-1){
                        if(v.deviceType==="Switch4"){
                            v.deviceState.power1=false;
                            v.deviceState.power2=false;
                            v.deviceState.power3=false;
                            v.deviceState.power4=false;
                        }
                        if(v.deviceType==="IrAirconditioner"){
                            v.deviceState.power="꺼짐";
                        }
                        if(v.deviceType==="LedStripRgbw2"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw1"){
                            v.deviceState.power=false;
                        }
                        if(v.deviceType==="LightRgbw4"){
                            v.deviceState.power=false;
                        }
                    }
                })
            }
        }
       this.setState({
        deviceList: deviceList,
        })
        setTimeout(() => {
            this.setState({
                loading: false,
                refresh: false,
            })
        }, 500);
    }
    
    getRecipe(familyId) {
        let recipeList=[];
        if (familyId === "0000001") {
            recipeList = [
                {
                    name: "안방 휴식모드",
                    sceneId: "mainroomRest"
                },
                {
                    name: "안방 영화모드",
                    sceneId: "mainroomMovie"
                },
                {
                    name: "거실 휴식모드",
                    sceneId: "livingroomRest"
                },
                {
                    name: "거실 영화모드",
                    sceneId: "livingroomMovie"
                },
                {
                    name: "전체 출근모드",
                    sceneId: "allGoToWork"
                },
                {
                    name: "전체 퇴근모드",
                    sceneId: "allLeaveWork"
                },
            ]
        }
        if (familyId === "0000002") {
            recipeList = [
                {
                    name: "홀 출근모드",
                    sceneId: "hallGoToWork"
                },
                {
                    name: "홀 퇴근모드",
                    sceneId: "hallLeaveWork"
                },
                {
                    name: "홀 낮타임모드",
                    sceneId: "hallDayTime"
                },
                {
                    name: "홀 밤타임모드",
                    sceneId: "hallNightTime"
                },
                {
                    name: "주방 출근모드",
                    sceneId: "kitchenGoToWork"
                },
                {
                    name: "주방 퇴근모드",
                    sceneId: "kitchenLeaveWork"
                },
            ]
        }
        this.setState({
            recipeList: recipeList,
        })
    }

    changeLocation(e) {
         // 상단 방 select 변경 이벤트
         const index = e.nativeEvent.target.selectedIndex;
         let name = e.nativeEvent.target[index].text
         let room = e.target.value;
         this.setState({room:room, roomName:name, refresh:true});
         this.getDeviceList(this.state.familyId, room);
         
         
    }

    toggleEnlarge(type) {
        // 전체화면 toggle 이벤트
        let elem = document.documentElement;
        if(type==='zoomIn') {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }
            this.setState({isEnlarge:true});
            $('body').css('overflow-y','hidden')
        } else if(type==="zoomOut") {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
            this.setState({isEnlarge:false});
            $('body').css('overflow-y','scroll')
        }
    }

    slideToggle(e, type) {
        // 레시피, 제품 리스트 slide 
        if(type==="openDevice") {
            $('.device-list').slideToggle('200');
        } else {
            $('.recipe-list').slideToggle('200');
        }
        this.setState({[type]:!this.state[type]})
    }

    handlePanelToggle(item){
        if(item.deviceState || item.deviceType.includes('Ir')){
            this.setState({panelToggle: true, selectedItem: item, key: Math.random()});
        }else{
            this.setState({panelToggle: false, selectedItem: null});
        }
    }

    handleItemPower(item) {
        this.setState({ key: Math.random() });
        this.setState({selectedItem: item})   
    }

    closePanelToggle(e){
        e.preventDefault();
        const element = document.querySelectorAll('.device-item');
        const element2 = document.querySelector('.device-setting');
        const closePanel = document.querySelector('.close-panel');
        let isChildren = false;
        element.forEach(elem => {
            if(elem.contains(e.target)) isChildren = true;
        })
        if ((!isChildren && !element2.contains(e.target)) || (closePanel && closePanel.contains(e.target)) ) {
            this.setState({panelToggle: false, selectedItem:null})
        }
    }

    render() {
        let recipeList = this.state.recipeList;
        let deviceList = this.state.deviceList;
        let roomList = this.state.roomList;

        const devicesResolved = (deviceList || []).reduce((prev, curr) => {
            (curr.deviceType !== 'IrDiy' && curr.deviceType !== "HomeCamera") && prev.push(curr);
            return prev;
        }, []);

        try {
            return (
                <div id="dashboard" onClick={(e)=> this.closePanelToggle} className={this.state.isEnlarge ? "enlarge page" : "page"}>
                    {this.state.loading ?
                        <Skeleton/>
                        :
                        <div className={this.state.panelToggle ? "dashboard-wrap open" : "dashboard-wrap "} onClick={this.closePanelToggle}>
                            <div className="top-select">
                                <span>데모 대시보드</span>
                                <span className="bar">/</span>
                               <span className="family-name">{this.state.familyName}</span>
                                <span className="bar">/</span>
                                {this.state.isEnlarge && 
                                    <React.Fragment>
                                        <span>{this.state.roomName}</span>
                                        <span className="close-btn" onClick={()=>this.toggleEnlarge('zoomOut')}><TimesIcon/></span>
                                    </React.Fragment>
                                }
                                <select onChange={(e)=>this.changeLocation(e)}>
                                    <option value="0">ALL</option>
                                    {(roomList && roomList.length!==0) && roomList.map((v, k)=>{
                                        return (
                                        <option value={v.room_id} key={v.room_id}>
                                            {v.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="enlarge-wrap">
                                <span className="enlarge-icon" onClick={()=>this.toggleEnlarge('zoomIn')}><EnlargeIcon /></span>
                            </div>
                            <div className="dashboard-wrap">
                                {/* 레시피 */}
                                <h3 onClick={(e)=>this.slideToggle(e, "openRecipe")}   
                                    className={this.state.openRecipe ? "open" : ""}>
                                    간편 레시피
                                    <ArrowIcon/>
                                </h3>
                                <div className="div"/>
                                <ul className="dashboard-list recipe-list">
                                    {(recipeList && recipeList.length!==0) && recipeList.map((v,k)=> {
                                        return (
                                            <RecipeItem item={v} key={v.sceneId}
                                                familyId={this.state.familyId}
                                                 familyName={this.state.familyName}
                                                 actionDevice={()=>this.getDeviceList(this.state.familyId, this.state.room)}/>
                                        )
                                    })}
                                </ul>
                                {/* 디바이스 */}
                                <h3 onClick={(e)=>this.slideToggle(e, "openDevice")}
                                    className={this.state.openDevice ? "open" : ""}>
                                    디바이스
                                    <ArrowIcon/>
                                </h3>
                                <div className="div"/>
                                <ul className="dashboard-list device-list">
                                    {devicesResolved.map((device, index) => {
                                        return (
                                          <DeviceItem
                                            item={device} key={device.id + index}
                                            familyId={this.state.familyId}
                                            familyName={this.state.familyName} roomName={this.state.roomName}
                                            actionDevice={(callback)=>this.getDeviceList(this.state.familyId, this.state.room, res=> callback(res))}
                                            toggle={this.state.toggle}
                                            handlePanelToggle={this.handlePanelToggle}
                                            handleItemPower={this.handleItemPower}
                                            demo={this.state.demo}
                                          />
                                        )
                                    })}
                                </ul>
                            </div>
                            {/* 새로고침 */}
                            {this.state.refresh && 
                                <Refresh/>
                            }
                        </div>
                    }
                    <div className={this.state.panelToggle ? "device-setting-wrap open" : "device-setting-wrap"}>
                        <DeviceSetting key={this.state.key} demo={this.state.demo} closePanel={this.closePanelToggle} selectedItem={this.state.selectedItem}/>
                    </div>
                </div>
            )
        } catch (error) {
            this.errorHandler.processError(error);
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        isRefresh: state.hejhome.isRefresh, 
        navigationWidth: state.hejhome.navigationWidth, 
    }
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
    setIsRefresh: (bool) => dispatch({
        type: 'setIsRefresh',
        isRefresh: bool,
    }),
});

DemoDashboard = connect(mapStateToProps, mapDispatchToProps)(DemoDashboard);

export default DemoDashboard;
